// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tableWrapper":"_2kvOOA","paymentPayoutTable":"_1M0LYw","infoBtn":"_2oXx6_"};